import Icon from '@forwardflow/ui/Icons'
import { mapStages } from '@forwardflow/helpers/utils'
import { DropDown } from '@forwardflow/ui'
import { ButtonInputToggle } from '@forwardflow/ui/ButtonInputToggle'
import { useState } from 'react'

export const AddStage = () => {
   const [dropdownOpen, setDropdownOpen] = useState(false)
   const [isToggled, setIsToggled] = useState(false)

   const handleOpenChange = (isDropdownOpen: boolean) => {
      setDropdownOpen(isDropdownOpen)
   }

   const handleToggle = (isToggled: boolean) => {
      setIsToggled(isToggled)
   }
   return (
      <>
         <div className="flex text-white gap-x-2 text-[12px] my-5">
            <Icon name="Info" className="text-white" />
            <span>
               We found a matching stage in FUB. Anyways you can also select
               another stage or create a new one
            </span>
         </div>
         <div className="flex md:items-center gap-y-2 flex-col md:flex-row gap-x-2 text-[12px] w-full bg-[#CDA8F0]/10 p-[10px] rounded-lg">
            <div className="flex items-center leading-none text-white gap-x-2">
               <img src="/images/ff-white.png" alt="ff" width={11} />
               <span>Leads with Appointment scheduled</span>
               <Icon name="arrow-right" className="!fill-white" width={10} />
            </div>
            <div className="flex items-center flex-1 gap-x-2">
               {!isToggled && (
                  <div className="flex-1">
                     <DropDown
                        options={mapStages}
                        onOpenChange={handleOpenChange}
                     />
                  </div>
               )}

               {!dropdownOpen && (
                  <div className="flex-1">
                     <ButtonInputToggle
                        inputPlaceholder="Stage name"
                        onToggle={handleToggle}
                        label="stage"
                     />
                  </div>
               )}
            </div>
         </div>
      </>
   )
}
